import { render, staticRenderFns } from "./SliderImages.vue?vue&type=template&id=9c1ae2e6&"
import script from "./SliderImages.vue?vue&type=script&lang=js&"
export * from "./SliderImages.vue?vue&type=script&lang=js&"
import style0 from "./SliderImages.vue?vue&type=style&index=0&id=9c1ae2e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports